import { Alert, Button, Modal } from "react-bootstrap";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";
import ThemedModal from "../../../@ui/Modal/ThemedModal";

interface RetrySuccessProps {
  onClose: () => void;
}

const RetrySuccess = ({ onClose }: RetrySuccessProps) => {
  return (
    <ThemedModal onHide={onClose} centered show={true}>
      <Modal.Header className="bg-secondary text-white" closeButton>
        <StyledModalTitle>Deferred Request Details</StyledModalTitle>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="success">
          Failed deferred request has been successfully re-queued
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={() => onClose()}>
          Ok
        </Button>
      </Modal.Footer>
    </ThemedModal>
  );
};

export default RetrySuccess;
